export const QB_FIELD_TYPES = {
  LOAN_VALUES: 'loanValues',
  LTV_VALUES: 'ltvValues',
  SUBJECT_VALUES: 'subjectValues',
  LAST_VALUES: 'lastValues',
  CREDIT_VALUES: 'creditValues',
};

export const QB_OPERATOR_TYPES = {
  EQUAL: 'equal',
  NOT_EQUAL: 'notEqual',
  GREATER_THAN: 'greaterThan',
  LESS_THAN: 'lessThan',
  CONTAINS: 'contains',
  NOT_CONTAINS: 'notNontains',
  BETWEEN: 'between',
  GREATER_THAN_OR_EQUAL: 'greaterThanOrEquals',
  LESS_THAN_OR_EQUAL: 'lessThanOrEquals',
  START_WITH: 'startsWith',
};

export const QB_GROUP_CONDITION_TYPES = {
  AND: true,
  OR: false,
};

export const QB_DRAG_TYPES = {
  FILTER: 'filter',
  GROUP: 'group',
};

export const QB_DRAG_LOCATIONS = {
  ABOVE: 'above',
  BELOW: 'below',
};

export const QB_EXPORT_FORMAT_TYPES = {
  DEFAULT: 'defaultFormat',
  XML: 'xmlFormat',
  SQL: 'sqlFormat',
  SAFESQL: 'sqlSafeFormat',
};

export const QB_ADD_FILTER_METHOD_TYPES = {
  IN_PLACE: 'inplace',
  APPEND: 'append',
};

export const QB_GROUP_FILTER_METHOD_TYPES = {
  IN_PLACE: 'inplace',
  APPEND: 'append',
};

export const QB_FIELD_SHARED_ACTIONS = {
  RESET_FIELD: 'resetField',
  RESET_OPERATOR: 'resetOperator',
  RESET_VALUE: 'resetValue',
};
